export const focusList = [
  { time: "17:40", tag: "综艺", title: "某综艺录制现场路透流出，嘉宾阵容和网传名单对不上" },
  { time: "18:05", tag: "剧集", title: "热播剧大结局当晚，男女主互动被网友逐帧解读" },
  { time: "18:30", tag: "舞台", title: "音乐节直拍冲上热榜，前奏一响全场跟唱" },
  { time: "19:10", tag: "代言", title: "品牌官宣新代言人，评论区两小时冲上十万条" },
  { time: "19:45", tag: "回应", title: "工作室发长文回应传闻，粉丝后援会随后跟进说明" },
  { time: "20:20", tag: "考古", title: "旧图被翻出重新对比，时间线和现在的说法对得上吗" },
];

export const featureList = [
  {
    id: "f1",
    badge: "今晚最热",
    tag: "剧集动态",
    title: "大结局当晚，那段三十秒的对视被网友截成了九宫格",
    summary:
      "傍晚物料一更新，讨论就从剧情跑到了演员本身。有人翻出开播前的采访，说台词处理其实早有伏笔，也有人只看那一眼，觉得不用解释。",
    meta: "热议 3.2 万 · 评论 4186",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20glowing%20smartphone%20screen%20resting%20on%20a%20warm%20wooden%20table%20at%20dusk%2C%20abstract%20geometric%20shapes%20on%20screen%2C%20limited%20amber%20and%20terracotta%20palette%2C%20minimal%20editorial%20vector%20art%2C%20soft%20long%20shadows%2C%20clean%20cream%20background%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=heyl-6pm-f1&orientation=landscape",
  },
  {
    id: "f2",
    badge: "",
    tag: "现场路透",
    title: "录制现场流出的几张图，把嘉宾阵容话题又推了一遍",
    summary: "和网传名单对不上，节目组暂时没有回应，评论区先把可能性列了个遍。",
    meta: "热议 1.8 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20two%20abstract%20speech%20bubbles%20facing%20each%20other%20in%20warm%20amber%20and%20terracotta%20tones%2C%20minimal%20editorial%20vector%20art%2C%20generous%20negative%20space%2C%20clean%20simple%20cream%20background%2C%20calm%20balanced%20composition%2C%20no%20text&width=800&height=600&seq=heyl-6pm-f2&orientation=landscape",
  },
  {
    id: "f3",
    badge: "",
    tag: "舞台直拍",
    title: "前奏一起全场跟唱，这段直拍在傍晚反复上热榜",
    summary: "有观众说现场比转播好听，也有人只关心那段清唱是不是即兴加的。",
    meta: "热议 1.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20abstract%20stage%20light%20beam%20at%20evening%20golden%20hour%2C%20warm%20amber%20and%20clay%20red%20limited%20palette%2C%20minimal%20editorial%20vector%20art%2C%20clean%20simple%20cream%20background%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=heyl-6pm-f3&orientation=landscape",
  },
  {
    id: "f4",
    badge: "",
    tag: "品牌官宣",
    title: "官宣文案写得克制，评论区却把两年前的旧照片翻了出来",
    summary: "新代言人的话题从商务跑到穿搭，连带同款搜索量也跟着涨。",
    meta: "热议 9642",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20abstract%20shopping%20tag%20and%20ribbon%20in%20warm%20amber%20and%20terracotta%20palette%2C%20minimal%20editorial%20vector%20art%2C%20clean%20simple%20cream%20background%2C%20soft%20shadow%2C%20no%20text&width=800&height=600&seq=heyl-6pm-f4&orientation=landscape",
  },
];

export const compareList = [
  {
    id: "c1",
    topic: "某热播剧选角",
    before: "开播前：网传阵容大换血，被唱衰成「必糊」预定。",
    after: "开播后：收视连涨三天，原班人马反倒成了最大加分项。",
    heat: "对比图转发 3.2 万",
  },
  {
    id: "c2",
    topic: "综艺剪辑争议",
    before: "预告里：镜头分配不均，被质疑刻意制造矛盾。",
    after: "正片后：完整版释出，节奏被夸「会剪」，风向直接调头。",
    heat: "对比图转发 1.8 万",
  },
  {
    id: "c3",
    topic: "歌手跨界演戏",
    before: "官宣时：跨界被嘲「演技劝退」，话题一片看衰。",
    after: "播出后：一段哭戏片段出圈，弹幕集体改口道歉。",
    heat: "对比图转发 2.6 万",
  },
];

export const replyList = [
  {
    id: "r1",
    who: "某工作室",
    time: "18:20",
    quote: "已关注到相关讨论，网传物料为剧照花絮，并非正式造型，感谢大家关心，作品见。",
    status: "已回应",
  },
  {
    id: "r2",
    who: "节目组",
    time: "18:55",
    quote: "录制现场秩序良好，网传「冲突」说法不实，完整片段将于本周内上线播出。",
    status: "已回应",
  },
  {
    id: "r3",
    who: "本人账号",
    time: "19:30",
    quote: "看到大家讨论啦，其实真就是普通工作照，别过度解读，新作品很快和大家见面。",
    status: "已回应",
  },
  {
    id: "r4",
    who: "品牌方",
    time: "20:05",
    quote: "合作以官方发布为准，其余渠道信息请谨慎辨别，感谢关注。",
    status: "待跟进",
  },
];

export const commentList = [
  {
    id: "m1",
    user: "瓜田里的猹",
    role: "吃瓜群众",
    text: "我就说我下午刷到的图怎么越看越眼熟，原来前后是同一天拍的，这对比放一起就说得通了。",
    likes: 1284,
    tag: "前后对比",
  },
  {
    id: "m2",
    user: "六点半准时到",
    role: "老瓜友",
    text: "下班路上刷到这条，晚饭都多吃了两碗。蹲一个当事人回应，今晚这波应该还有后续。",
    likes: 966,
    tag: "晚间吃瓜",
  },
  {
    id: "m3",
    user: "理性吃瓜协会",
    role: "评论员",
    text: "建议先看完整片段再下定论，剪辑节奏这事儿真不能只看预告，等一个完整版。",
    likes: 742,
    tag: "理性讨论",
  },
  {
    id: "m4",
    user: "夜宵配瓜",
    role: "潜水党",
    text: "评论区比正片好看，这波我站原片完整版，前后对比图我先收藏了。",
    likes: 511,
    tag: "围观",
  },
];

export const timelineList = [
  { time: "17:30", title: "预告放出", desc: "傍晚第一波物料上线，相关话题开始起量。" },
  { time: "18:00", title: "首页上新", desc: "黑料六点整点更新，傍晚新料集中亮相。" },
  { time: "19:00", title: "讨论升温", desc: "前后对比图被翻出，网友开始逐帧比对细节。" },
  { time: "20:30", title: "当事人回应", desc: "相关方陆续发布说明，评论区风向出现变化。" },
  { time: "22:00", title: "晚间复盘", desc: "热评汇总更新，今天这波瓜基本吃明白了。" },
];

export const topicList = [
  "傍晚爆料",
  "前后对比",
  "当事人回应",
  "综艺现场",
  "剧集动态",
  "舞台直拍",
  "品牌官宣",
  "网友热议",
  "下班看料",
  "晚间吃瓜",
  "旧图新瓜",
  "评论区考古",
];

export const statList = [
  { value: "12", label: "今日傍晚新料" },
  { value: "86", label: "网友热议主题" },
  { value: "5", label: "当事人回应" },
  { value: "23:00", label: "晚间更新截止" },
];